export function humanReadableStringToAddress(str) {
	str = str.replace(/[,;/]/, ' ');

	let firstPart = /^[^\d]*/.exec(str);
	if (firstPart) {
		firstPart = firstPart[0];
		firstPart = firstPart.trim();
		//firstPart = capitalize(firstPart);
	}

	let lastPart = /\d([^\d]+)$/.exec(str);
	if (lastPart) {
		lastPart = lastPart[1].trim().substr(0, 1);
	}

	let number = /\d+/.exec(str);
	if (number) {
		number = parseInt(number[0], 10);
	}

	return {
		street: firstPart || null,
		number: number || null,
		suffix: lastPart || null,
	};
}
